import { appConfig } from '../../../../../config/customization';
import Device from '../../../../../constants/deviceSizes';

const borderStyle = `1px solid ${appConfig.colors.bordersGray}`;

export default {
  passwordContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    userSelect: 'none'
  },
  inactive: {
    backgroundColor: appConfig.colors.passwordContainerInactive
  },
  active: {
    backgroundColor: appConfig.colors.white
  },
  configurationField: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 25px 0 36px',
    alignItems: 'center',
    height: '3rem',
    [Device.mobile]: {
      padding: 10
    }
  },
  changePasswordField: {
    cursor: 'pointer',
    backgroundColor: appConfig.colors.passwordContainerInactive
  },
  changePasswordActive: {
    boxShadow: 'inset -2px 73px 46px -87px rgba(0,0,0,1)',
    backgroundColor: 'transparent'
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 25px 5px 36px',
    borderBottom: borderStyle,
    [Device.mobile]: {
      padding: 10
    }
  },
  arrow: {
    marginLeft: 10
  },
  configurationLabel: {
    width: '100%',
    textAlign: 'left',
    marginLeft: 6
  },
  icons: {
    width: 20,
    height: 20,
    marginRight: 10
  },
  iconAndTitleContainer: {
    display: 'flex',
    alignItems: 'center'
  }
};
